import React from 'react';
import './LoadingAnimation.css';

const LoadingAnimation = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner-circle"></div>
      <p className="loading-message">
        Traitement de votre demande. Veuillez patienter...
      </p>
    </div>
  );
};

export default LoadingAnimation;
